import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson, getErrMsg } from '../service/serviceUtil';

import ContextualMessage from '../components/contextualMessage';
import UserDisplay from '../components/userDisplay';

class VerifRecoveryCode extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            code: "",
            error: null,
            txtMsg: null,
            typeMsg: null,
            errorApi: false
        };
    }

    get labels() {
        return chainesLocales['VerifRecoveryCode'][this.props.lang];
    }

    render() {
        const displaySubmitButton = (!this.state.errorApi && !this.state.error && !this.state.txtMsg && !this.state.typeMsg);

        return (
            <form className="text-left" onSubmit={this.onSubmit.bind(this)}>
                <h1>{this.labels.title}</h1>
                <UserDisplay user={this.props.user.username} lang={this.props.lang} />
                {displaySubmitButton ? <ContextualMessage type="success" showIcon={false} content={this.labels.msgPreEmail + '<br><br>' + this.props.user.useremail + '<br><br>' + this.labels.msgPostEmail} /> : null}
                {
                    this.state.error ? <ContextualMessage type="error" content={getErrMsg(this.state.error, this.props.lang)} /> : null
                }
                {
                    this.state.txtMsg ? <ContextualMessage type={this.state.typeMsg} showIcon={false} content={this.state.txtMsg} /> : null
                }
                {
                    this.state.errorApi ? <ContextualMessage type="error" showIcon={false} content={chainesLocales['ErrApi'][this.props.lang].msg} /> : null
                }
                <div className="row">
                    <div className="col">
                        {displaySubmitButton ? 
                        <div className="form-group">
                            <label htmlFor="code" className="font-weight-bold" style={{ fontSize: "1.1rem" }}>{this.labels.labelCode}</label>
                            <input className="form-control" id="code" type="text" maxLength={6} size={6} style={{ width: 100 }} value={this.state.code} onChange={this.onChangeCode.bind(this)} />
                        </div> : null}
                        <div>
                            {displaySubmitButton ? <button className="btn btn-primary mr-3" type="submit" disabled={!this.state.code}><span className="label">{this.labels.button}</span><span className="spinner"></span></button> : null}
                            <button className="btn btn-secondary" type="button"><span className="label" onClick={this.onRetourClick.bind(this)}>{this.labels.retourButton}</span><span className="spinner"></span></button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    onChangeCode(e) {
        this.setState({ code: e.target.value.trim() });
    }

    onRetourClick(e) {
        e.preventDefault();

        this.props.onPageSuccess({ verifRC: { newPage: "demande-mot-passe" }});
    }

    onSubmit(e) {
        e.preventDefault();
        
        if (document.querySelector) {
            document.querySelector('button[type="submit"]').disabled = true;
            if (document.body.classList) document.querySelector('button[type="submit"]').classList.add('loading');
        }

        let formData = new FormData();

        formData.append("code", this.state.code.trim());
        formData.append("lang", this.props.lang);
            
        let defaultParams = {
            lang: this.props.lang,
            suffixe: this.props.suffixe
        };

        let fetchOptions = {
            method: "POST",
            credentials: "same-origin",
            body: formData
        };

        getJson('verifRecoveryCode', defaultParams, fetchOptions).then(data => {
            if (data === true) {
                this.props.onPageSuccess({ verifRC: { newPage: "confirm-recovery-code" }});
            } else {
                this.setState({ error: data.error, typeMsg: data.type, txtMsg: data.message, errorApi: ((!data.error && !data.message) ? true : false) });
            }
        }).catch(err => {
            console.error("Erreur API creer courriel: " + err);
    
            this.setState({ errorApi: true, error: null, typeMsg: null, txtMsg: null });
        });
    }
}

export default VerifRecoveryCode;